var _excluded = ["children", "overflow"],
    _excluded2 = ["children", "width", "maxWidth", "maxHeight"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { Position, Portal, Stack, Flex, Box } from "./..";
import FocusLock, { AutoFocusInside } from 'react-focus-lock';

var OverlayBackdrop = function OverlayBackdrop(_ref) {
  var onDismiss = _ref.onDismiss,
      invertBackdrop = _ref.invertBackdrop;
  return /*#__PURE__*/React.createElement(Position, {
    position: "absolute",
    top: "0",
    right: "0",
    left: "0",
    bottom: "0",
    sx: {
      backgroundColor: invertBackdrop ? 'rgba(255,255,255, 0.4)' : 'rgba(0,0,0,0.2)'
    },
    onClick: onDismiss
  });
};

OverlayBackdrop.displayName = 'OverlayBackdrop';
var OverlayContainer = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var children = _ref2.children,
      _ref2$zIndex = _ref2.zIndex,
      zIndex = _ref2$zIndex === void 0 ? 'overlay' : _ref2$zIndex;
  return /*#__PURE__*/React.createElement(Portal, null, /*#__PURE__*/React.createElement(FocusLock, {
    autoFocus: true,
    returnFocus: true,
    crossFrame: false
  }, /*#__PURE__*/React.createElement(AutoFocusInside, null, /*#__PURE__*/React.createElement(Position, {
    as: Flex,
    ref: ref,
    position: "fixed",
    top: "0",
    left: "0",
    right: "0",
    bottom: "0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: zIndex
  }, children))));
});
OverlayContainer.displayName = 'OverlayContainer';
var OverlayScroll = /*#__PURE__*/React.forwardRef(function (_ref3, ref) {
  var children = _ref3.children,
      _ref3$overflow = _ref3.overflow,
      overflow = _ref3$overflow === void 0 ? 'auto' : _ref3$overflow,
      others = _objectWithoutProperties(_ref3, _excluded);

  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    overflow: overflow
  }, others), children);
});
OverlayScroll.displayName = 'OverlayScroll';
export var Overlay = /*#__PURE__*/React.forwardRef(function (_ref4, ref) {
  var _ref4$dismissOnBackdr = _ref4.dismissOnBackdrop,
      dismissOnBackdrop = _ref4$dismissOnBackdr === void 0 ? true : _ref4$dismissOnBackdr,
      children = _ref4.children,
      onDismiss = _ref4.onDismiss,
      _ref4$invertBackdrop = _ref4.invertBackdrop,
      invertBackdrop = _ref4$invertBackdrop === void 0 ? false : _ref4$invertBackdrop,
      zIndex = _ref4.zIndex;
  return /*#__PURE__*/React.createElement(OverlayContainer, {
    ref: ref,
    zIndex: zIndex
  }, /*#__PURE__*/React.createElement(OverlayBackdrop, {
    onDismiss: dismissOnBackdrop ? onDismiss : undefined,
    invertBackdrop: invertBackdrop
  }), children);
});
Overlay.displayName = 'Overlay';
export var OverlayContent = /*#__PURE__*/React.forwardRef(function (_ref5, ref) {
  var children = _ref5.children,
      _ref5$width = _ref5.width,
      width = _ref5$width === void 0 ? '560px' : _ref5$width,
      _ref5$maxWidth = _ref5.maxWidth,
      maxWidth = _ref5$maxWidth === void 0 ? '80%' : _ref5$maxWidth,
      _ref5$maxHeight = _ref5.maxHeight,
      maxHeight = _ref5$maxHeight === void 0 ? '80%' : _ref5$maxHeight,
      others = _objectWithoutProperties(_ref5, _excluded2);

  return /*#__PURE__*/React.createElement(Position, _extends({
    position: "relative",
    as: Stack,
    ref: ref,
    width: width,
    maxHeight: maxHeight,
    maxWidth: maxWidth,
    margin: "auto",
    sx: {
      backgroundColor: 'white',
      borderRadius: '2px'
    }
  }, others), /*#__PURE__*/React.createElement(OverlayScroll, {
    height: "100%"
  }, children));
});
OverlayContent.displayName = 'OverlayContent';